import { useMemo } from 'react'

import { useDependencyManagerContext } from '@foreign-clientos/dependency-manager'
import { Catalog } from '@foreign-clientos/dependency-manager/utils/getCommonsNorthboundAPIs/types'

export function useODSessionContext() {
  const { northboundAPIs } = useDependencyManagerContext()
  const {
    sessionContext: { onboardingContext, derivedAttributes, app, device, user },
  } = northboundAPIs.v1.store.state.onboarding

  const catalog = useMemo(
    (): Catalog | undefined => derivedAttributes?.catalogMgtSvc,
    [derivedAttributes],
  )

  const paasSubscription = useMemo(
    () => derivedAttributes?.subscriptionStateSvc,
    [derivedAttributes],
  )

  const entry = useMemo(
    () => onboardingContext?.entry,
    [onboardingContext?.entry],
  )

  const experience = useMemo(
    () => onboardingContext?.experience,
    [onboardingContext?.experience],
  )

  const productFamily = useMemo(
    () => onboardingContext?.productFamily,
    [onboardingContext?.productFamily],
  )

  const osType = useMemo(() => app?.osType, [app])

  const platformIdentifier = useMemo(
    () => derivedAttributes?.pls?.platformIdentifier,
    [derivedAttributes],
  )

  const productNumber = useMemo(() => device?.productNumber, [device])

  const bizModelHint = useMemo(
    () => onboardingContext?.bizModelHint,
    [onboardingContext?.bizModelHint],
  )

  const deviceName = useMemo(() => user?.selectedDeviceName, [user])

  const deviceLocation = useMemo(() => user?.selectedDeviceLocation, [user])

  return useMemo(
    () => ({
      catalog,
      entry,
      productFamily,
      experience,
      osType,
      platformIdentifier,
      productNumber,
      paasSubscription,
      bizModelHint,
      deviceName,
      deviceLocation,
    }),
    [
      catalog,
      entry,
      productFamily,
      experience,
      osType,
      platformIdentifier,
      productNumber,
      paasSubscription,
      bizModelHint,
      deviceName,
      deviceLocation,
    ],
  )
}
